var map = {
	"./strange-double.a4f153b4.png": 3165,
	"./strange-double.png": 6769,
	"./strange-single.eb514259.png": 4465,
	"./strange-single.png": 3874,
	"./strange1.eb514259.png": 1749,
	"./strange1.png": 9398,
	"./strange2.731768c2.png": 120,
	"./strange2.png": 3373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 140;